<template>
  <transition>
    <div v-if="isShow" class="notification">
      <div class="notification-content">
        <div class="message">
          <p v-if="isSuccess">クーポンが付与されました</p>
          <p v-else style="margin-top: -10px">
            <b>エラーが発生し、クーポンが付与されませんでした</b>
          </p>
        </div>
        <div class="action">
          <button v-if="isSuccess" @click="goToExternalCouponTab()">
            確認する
          </button>
          <button v-else @click="retry()">リトライ</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "ThePassIssuedExternalCouponNotification",
  props: {
    retry: {
      type: Function,
      required: true,
    },
    isNotTargetVersion: {
      type: Boolean,
    },
    openCouponVersionWarning: {
      type: Function,
    },
  },
  setup(props) {
    const isShow = ref(false);
    const isSuccess = ref(false);

    const showNotification = (isSuccessArg) => {
      isShow.value = true;
      isSuccess.value = isSuccessArg;
    };

    const hideNotification = () => {
      isShow.value = false;
    };

    const goToExternalCouponTab = () => {
      if (props.isNotTargetVersion && props.openCouponVersionWarning) {
        props.openCouponVersionWarning();
      } else {
        console.log("goToExternalCouponTab");
        nativeHandlerService.ncOpenExternalCouponIndex();
      }
    };

    const retry = async () => {
      await props.retry();
    };

    return {
      isShow,
      isSuccess,
      showNotification,
      hideNotification,
      goToExternalCouponTab,
      retry,
    };
  },
};
</script>

<style lang="scss" scoped>
.notification {
  float: left;
  margin: 0;
  width: 100%;
  position: relative;
  z-index: 9999;
  background-color: #fdd000;
  border-radius: 0;
  height: 117px;
}
.notification.active {
  top: 0px;
  transform: top 1s;
}
.notification-content {
  padding-left: 20px;
  top: 50px;
  position: relative;
}
.message {
  float: left;
  width: 60%;
  font-size: 18px;
  text-align: left;
  height: 100%;
  padding-top: 10px;
}
.message p {
  position: relative;
  top: 30%;
  line-height: 1;
}
.action {
  float: right;
  padding-right: 20px;
}
.action button {
  background: #fdd000;
  border-radius: 2px;
  border-width: 1px;
  font-size: 18px;
  border-color: #000000;
  color: #000000;
}

.v-enter-from,
.v-leave-to {
  top: -100px;
}

.v-enter-active,
.v-leave-active {
  transition: top 0.5s;
}

.v-enter-to,
.v-leave-from {
  top: 0px;
}
</style>
